export const ACTUALIZAR_LIST_DOCUMENTO = "ACTUALIZAR_LIST_DOCUMENTO";
export const CALCULAR_MANTENIMIENTOS_DOCUMENTOS = "CALCULAR_MANTENIMIENTOS_DOCUMENTOS"
export const AGREGAR_DOCUMENTO = "AGREGAR_DOCUMENTO";  
export const MODIFICAR_DOCUMENTO = "MODIFICAR_DOCUMENTO";